/** Global search (ADR 0043, 2026-10-10). Same keys as `search.fr.ts`. */
export const searchEn = {
  title: 'Search',
  subtitle:
    'Projects, jobs, workflows, infrastructures, endpoints and catalog of the organization. Only what you can read is shown.',
  placeholder: 'Search by name or description…',
  label: 'Search terms',
  hint: 'Every word is required; the start of a word is enough. Secrets, identities and users are never searched.',
  prompt: 'Type at least one word.',
  empty: {
    title: 'No result',
    description: 'Nothing you can read matches “{{query}}”.',
  },
  count_one: '{{count}} result',
  count_other: '{{count}} results',
  columns: {
    type: 'Type',
    name: 'Name',
    description: 'Description',
    updated: 'Updated',
  },
  types: {
    project: 'Project',
    job: 'Job',
    workflow: 'Workflow',
    infrastructure: 'Infrastructure',
    endpoint: 'Endpoint',
    catalog: 'Catalog',
    database: 'Database',
    table: 'Table',
  },
  filter: 'Type',
} as const;
